import React from "react";
import {connect} from "react-redux";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ResponsiveContainer,
    XAxis,
    YAxis,
    LineChart,
    Line,
    Tooltip,
    Brush
} from "recharts";
import {Visibility, VisibilityOff, Delete, CloudDownload} from '@material-ui/icons';
import {Paper, Typography, Button, Checkbox, InputLabel, Select, MenuItem, FormControl} from "@material-ui/core";
import {INotificacion, IParcela, sistemasProduccion} from "../../../types";
import axios from "axios";
import {userService} from "../../../services/UserService";
import * as XLSX from "xlsx";
import {KeyboardDateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateUtils from "@date-io/moment";

const config = require('../../../config.json');
const texts = require('../../../texts/riegoneto.json')


interface IProps {
    notify(notification: INotificacion): void
    parcela: string
    idioma: string
}

interface Istate {
    data: Record<string, number | string | null>[]
    filteredData: Record<string, number | string | null>[]
    toPrint: Record<string, string|boolean>[]
    acumulado: boolean
    sector: string
    metodo: string
    color: string
    sectores: string[]
    metodos: string[]
    colores: string[]
    text: Record<string, string>
    inicio: null | Date
}

class HistoricoRiego extends React.Component<IProps, Istate> {

    state: Istate = {
        data: [],
        filteredData: [],
        toPrint: [],
        acumulado: true,
        sector: '',
        metodo: '',
        color: '',
        sectores: [],
        metodos: ["REAL", "RPAS-HIBRIDA", "SATELITAL", "FAO"],
        colores: [
            "#CB4335",
            "#3498DB",
            "#2ECC71",
            "#F1C40F",
            "#D35400",
            "#884EA0",
            "#124065",
            "#616A6B"
        ],
        text: texts[this.props.idioma],
        inicio: null
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        if (this.state.inicio !== nextState.inicio) {
            if (nextState.inicio === null) {
                this.setState({filteredData: this.state.data})
            } else {
                const newData: Record<string, number | string | null>[] = []
                let cnt = -1
                const origen_acumulados: Record<string, number> = {}
                for (const d of this.state.data) {
                    if (new Date((d.name as string).split('/').reverse().join('-')) < nextState.inicio) {
                        cnt += 1
                        continue
                    }
                    if (newData.length === 0 && cnt >= 0) {
                        for (const sector of Object.keys(this.state.data[cnt - 1])) {
                            if (sector.endsWith("_acumulado")) {
                                if (this.state.data[cnt - 1][sector] === null) {
                                    origen_acumulados[sector] = 0
                                } else {
                                    origen_acumulados[sector] = this.state.data[cnt][sector] as number
                                }
                            }
                        }
                    }

                    const ok_d = {...d}
                    for (const sector of Object.keys(origen_acumulados)) {
                        if (ok_d[sector] !== null) {
                            ok_d[sector] = Math.round((ok_d[sector] as number - origen_acumulados[sector])*100)/100
                        }
                    }

                    newData.push(ok_d)
                }
                this.setState({filteredData: newData})
            }
        }

        return true
    }

    componentDidMount() {
        const url: string = config.url+`/get/irrigation/history?parcela=${this.props.parcela}`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                let sectores: string[] = []
                Object.keys(res.data["datos"][0]).filter(el => el.endsWith('_FAO')).map(el => sectores.push(el.split('_FAO')[0]))

                const okData: Record<string, number | string | null>[] = []

                const data = res.data["datos"] as Record<string, number | string | null>[]

                for (const d of data) {
                    let ok_d = {...d}
                    for (const sector of Object.keys(d)) {
                        if (sector === "name") continue
                        if (d[sector] === null) continue
                        ok_d[sector] = Math.round((d[sector] as number) * 100)/100
                    }
                    okData.push(ok_d)
                }

                this.setState({
                    data: okData,
                    filteredData: okData,
                    sectores: sectores
                })
            })
            .catch((error) => {
                if (error.response.status !== 404) {
                    this.props.notify({message: 'Error interno', variant: 'error'})
                }
            })
    }

    handleDownload = (x: Record<string, string|boolean>) => {
        const data: Record<string, string|number|null>[] = []
        if (x.metodo === "REAL") {
            let cnt = 0
            let inicio = ""
            let fin = ""
            let total = 0
            const _data: Record<string, string|number|null>[] = []
            for (const element of this.state.filteredData) {
                if (element[`${x.sector}_${x.metodo}`] === null) {

                    if (inicio !== "") {
                        fin = this.state.filteredData[cnt-1].name as string
                        _data.push({
                            "dias" : inicio + " - " + fin,
                            "diario (m^3)": total
                        })
                    }

                    inicio = ""
                    fin = ""
                    total = 0
                    cnt += 1
                    continue
                }

                if (inicio === "") {
                    inicio = element.name as string
                    total = element[`${x.sector}_${x.metodo}`] as number
                    cnt += 1
                    continue
                }

                if (element[`${x.sector}_${x.metodo}`] as number === this.state.filteredData[cnt-1][`${x.sector}_${x.metodo}`] as number) {
                    total += element[`${x.sector}_${x.metodo}`] as number
                    cnt += 1
                } else {
                    fin = this.state.filteredData[cnt-1].name as string
                    _data.push({
                        "dias" : inicio + " - " + fin,
                        "diario (m^3)": total
                    })

                    inicio = element.name as string
                    total = element[`${x.sector}_${x.metodo}`] as number
                    fin = ""

                    cnt += 1
                }
            }
            cnt = 0
            for (const d of _data){
                if (cnt === 0) {
                    data.push({
                        "periodo" : d["dias"],
                        "diario (m^3)": d["diario (m^3)"] as number,
                        "acumulado (m^3)": d["diario (m^3)"] as number
                    })
                } else {
                    data.push({
                        "periodo" : d["dias"],
                        "diario (m^3)": d["diario (m^3)"] as number,
                        "acumulado (m^3)": (data[cnt-1]["acumulado [m^3]"] as number) + (d["diario (m^3)"] as number)
                    })
                }
                cnt += 1
            }
        } else {
            for (const element of this.state.filteredData) {
                data.push({
                    "dia" : element.name,
                    "diario (m^3)": element[`${x.sector}_${x.metodo}`],
                    "acumulado [m^3]": element[`${x.sector}_${x.metodo}_acumulado`],
                })
            }
        }

        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Page1");
        XLSX.writeFile(workbook, `recomendacion_riego_${x.sector}_${x.metodo}` + '.xlsx');
    }

    render() {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%',
                    height: 'fit-content'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: 30,
                        marginLeft: 20,
                        fontFamily: "Poppins"
                    }}
                >
                    {this.state.text["45"]}
                </Typography>

                <Paper
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: "fit-content",
                        borderRadius: 20,
                    }}
                >


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: '100%',
                            height: 400
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                width: "100%",
                                justifyContent: "space-evenly",
                                marginTop: 10,
                                marginBottom: -20,
                                zIndex: 10
                            }}
                        >
                            <div
                                style={{
                                    width: 300,
                                    height: "100%"
                                }}
                            >

                                <MuiPickersUtilsProvider
                                    locale={this.props.idioma}
                                    utils={DateUtils}
                                >
                                    <KeyboardDatePicker
                                        variant="inline"
                                        label="Seleccionar Inicio:"
                                        value={this.state.inicio !== null? this.state.inicio : null}
                                        onChange={(f) => {
                                            if (f !== null) this.setState({inicio: f.toDate()})
                                        }}
                                        format="DD/MM/YYYY"
                                    />
                                </MuiPickersUtilsProvider>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: 200,
                                    height: "100%"
                                }}
                            >
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        color: "#4C494B"
                                    }}
                                >
                                    {this.state.text["46"]}
                                </Typography>
                                <Checkbox
                                    color={"primary"}
                                    checked={this.state.acumulado}
                                    onChange={() => this.setState({acumulado: !this.state.acumulado})}
                                />
                            </div>
                        </div>

                        <ResponsiveContainer
                            width="100%"
                            height="100%"
                        >
                            <LineChart
                                data={this.state.data}
                                margin={{
                                    top: 30,
                                    right: 50,
                                    left: 50,
                                    bottom: 20,
                                }}
                            >
                                <CartesianGrid/>
                                <Tooltip/>

                                {this.state.toPrint.filter(el => el["visible"] as boolean).map((el, i) =>
                                    <Line
                                        dataKey={this.state.acumulado?
                                            `${el["sector"]}_${el["metodo"]}_acumulado`
                                            :
                                            `${el["sector"]}_${el["metodo"]}`
                                        }
                                        type="monotone"
                                        stroke={el["color"] as string}
                                        strokeWidth={3}
                                    />
                                )}

                                <XAxis dataKey="name" angle={0} dy={5}/>
                                <YAxis
                                    label={{
                                        value: 'm³',
                                        angle: -90,
                                        position: 'Left',
                                        fontSize: 20,
                                        dx: -40,
                                        fontFamily: "Poppins"
                                    }}
                                />
                                <YAxis yAxisId="right" orientation="right" label={{ value: '', angle: -90, position: 'Rigth', fontSize: 20, dx: 40}} />
                                <Brush
                                    height={30}
                                    stroke="#4C494B"
                                    dataKey="name"
                                />
                            </LineChart>
                        </ResponsiveContainer>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: '100%',
                            height: 400,
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                fontSize: 24,
                                color: "#4C494B",
                                width: "95%",
                                marginTop: 40
                            }}
                        >
                            {this.state.text["47"]}
                        </Typography>

                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '95%',
                            justifyContent: "space-between"
                        }}
                        >
                            <FormControl
                                style={{
                                    width: 150
                                }}
                            >
                                <InputLabel style={{fontSize: 16, fontFamily: "Poppins"}}>{this.state.text["48"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    value={this.state.sector}
                                    onChange={e => {
                                        this.setState({sector: e.target.value as string})
                                    }}
                                >
                                    {this.state.sectores.map(el =>{
                                        if (el === "") {
                                            return <MenuItem key={'Ninguno'} value={'Ninguno'}>
                                                <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Ninguno</Typography>
                                            </MenuItem>
                                        } else {
                                            return <MenuItem key={el} value={el}>
                                                <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>{el}</Typography>
                                            </MenuItem>
                                        }
                                    })}
                                </Select>
                            </FormControl>
                            <FormControl
                                style={{
                                    width: 150,
                                    marginLeft: 20
                                }}
                            >
                                <InputLabel style={{fontSize: 16, fontFamily: "Poppins"}}>{this.state.text["49"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    value={this.state.metodo}
                                    onChange={e => {
                                        this.setState({metodo: e.target.value as string})
                                    }}
                                >
                                    {this.state.metodos.map(el =>{
                                        if (el === "") {
                                            return <MenuItem key={'Ninguno'} value={'Ninguno'}>
                                                <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>Ninguno</Typography>
                                            </MenuItem>
                                        } else {
                                            return <MenuItem key={el} value={el}>
                                                <Typography style={{fontSize: 16, fontFamily: "Poppins"}}>{el}</Typography>
                                            </MenuItem>
                                        }
                                    })}
                                </Select>
                            </FormControl>
                            <FormControl
                                style={{
                                    width: 70,
                                    marginLeft: 20
                                }}
                            >
                                <InputLabel style={{fontSize: 16, fontFamily: "Poppins"}}>{this.state.text["50"]}</InputLabel>
                                <Select
                                    inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    value={this.state.color}
                                    onChange={e => {
                                        this.setState({color: e.target.value as string})
                                    }}
                                >
                                    {this.state.colores.map(el =>
                                        <MenuItem key={el} value={el}>
                                            <Paper
                                                style={{
                                                    width: 40,
                                                    borderRadius: 4,
                                                    backgroundColor: el
                                                }}
                                            >
                                                <Typography style={{fontSize: 16, fontFamily: "Poppins", color: el}}>O</Typography>
                                            </Paper>
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                style={{
                                    marginLeft: 20,
                                    borderRadius: 6,
                                    height: 35,
                                    alignSelf: "flex-end"
                                }}
                                disabled={this.state.sector === '' || this.state.metodo === '' || this.state.color === ''}
                                onClick={() => {
                                    let toPrint = []
                                    toPrint.push({
                                        visible: true,
                                        sector: this.state.sector,
                                        metodo: this.state.metodo,
                                        color: this.state.color
                                    })
                                    for (let element of this.state.toPrint) {
                                        toPrint.push(element)
                                    }
                                    this.setState({toPrint: toPrint})
                                }}
                            >
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        fontSize: 16,
                                        textTransform: "none"
                                    }}
                                >
                                    {this.state.text["51"]}
                                </Typography>
                            </Button>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: '95%',
                                height: '100%',
                                marginBottom: 30,
                                marginTop: 10,
                                overflow: "auto"
                            }}
                        >
                            {this.state.toPrint.map((el, i) =>
                                <Paper
                                    key={i}
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: '100%',
                                        height: 30,
                                        backgroundColor: '#eee',
                                        marginTop: 5
                                    }}
                                >
                                    <Paper
                                        style={{
                                            width: 40,
                                            height: 30,
                                            borderRadius: 4,
                                            backgroundColor: el.color as string
                                        }}
                                    >
                                        <Typography style={{fontSize: 16, fontFamily: "Poppins", color: el.color as string}}>O</Typography>
                                    </Paper>

                                    <Typography
                                        style={{
                                            fontFamily: "Poppins",
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            textTransform: "none"
                                        }}
                                    >
                                        {el.sector}
                                    </Typography>

                                    <Typography
                                        style={{
                                            fontFamily: "Poppins",
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            textTransform: "none"
                                        }}
                                    >
                                        {el.metodo}
                                    </Typography>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            height: 30
                                        }}
                                    >
                                        {el.visible?
                                            <Button
                                                variant={"outlined"}
                                                onClick={() => {
                                                    let toPrint = []
                                                    let new_element = el
                                                    new_element["visible"] = false
                                                    for (let element of this.state.toPrint) {
                                                        if (element === el) toPrint.push(new_element)
                                                        else toPrint.push(element)
                                                    }
                                                    this.setState({toPrint: toPrint})
                                                }}
                                            >
                                                <Visibility style={{color: "#4C494B"}}/>
                                            </Button>
                                            :
                                            <Button
                                                variant={"outlined"}
                                                onClick={() => {
                                                    let toPrint = []
                                                    let new_element = el
                                                    new_element["visible"] = true
                                                    for (let element of this.state.toPrint) {
                                                        if (element === el) toPrint.push(new_element)
                                                        else toPrint.push(element)
                                                    }
                                                    this.setState({toPrint: toPrint})
                                                }}
                                            >
                                                <VisibilityOff style={{color: "#4C494B"}}/>
                                            </Button>
                                        }

                                        <Button
                                            variant={"outlined"}
                                            onClick={() => this.handleDownload(el)}
                                        >
                                            <CloudDownload/>
                                        </Button>

                                        <Button
                                            variant={"outlined"}
                                            onClick={() => {
                                                let toPrint = []
                                                for (let element of this.state.toPrint) {
                                                    if (element === el) continue
                                                    toPrint.push(element)
                                                }
                                                this.setState({toPrint: toPrint})
                                            }}
                                        >
                                            <Delete
                                                style={{
                                                    color: "#C62828"
                                                }}
                                            />
                                        </Button>

                                    </div>

                                </Paper>
                            )}
                        </div>

                    </div>

                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    parcela: state.navegacion.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(HistoricoRiego);
